import { useMutation, useQueryClient } from "react-query";
import { endpoints } from "utils/endpoints";
import http from "utils/http";

const finalQuote = (postData) => {
  return http().post(endpoints.quotes.getFinalQuote, postData);
};

export function useFinalQuote() {
  const queryClient = useQueryClient();
  return useMutation(finalQuote, {
    onSuccess: () => {
      queryClient.invalidateQueries(["finalQuote"]);
    },
    onError: (errorData) => {
      const errorMessage = errorData?.error?.message || errorData?.message;
      alert(errorMessage);
    },
  });
}
